import { ResourceProps } from 'ra-core';
import TelescopeRequestShow from './TelescopeRequestShow';
const TelescopeRequestsResource: ResourceProps = {
  name: 'telescope/requests',
  show: TelescopeRequestShow,
};

export default TelescopeRequestsResource;
